export const ENV_APP_NAME = '/FileImportHub';
export const PORT = process.env.REACT_APP_DEV_PORT;

export const API_TIME_OUT = 35000;

export const HOST = {
	BASE_APIM_URL: 'https://api-quarterly.paycor.com',
	BASE_HCM_URL: 'https://HCM-quarterly.paycor.com',
	BASE_SECURE_URL: 'https://secure-quarterly.paycor.com',
	PUBLIC_API_URL_BASE: 'https://apis-quarterly.paycor.com',
	UI_URL_BASE: `https://local.paycor.com:${PORT}${ENV_APP_NAME}`,
	environment: 'local',
	APIM_SUBSCRIPTION_KEY: 'ae5138e498794a548a90546ac35fcff9',
	AUTHENTICATION_URL: 'https://hcm-quarterly.paycor.com',
	SESSION_TIMEOUT_LOCAL_MODE: true
};

export const OAUTH = {
	CLIENTID: 'FileImportHubUI',
	SCOPE: 'FileImportHubUiScope'
};

export const APPSETTINGS = {
	IN_PROGRESS_REFRESH_INTERVAL: `20`
};

export const SECURITYSETTINGS = {
	client_id: OAUTH.CLIENTID,
	redirect_uri: `${HOST.UI_URL_BASE}/oauth/silent_renew.html`,
	response_type: 'token',
	scope: OAUTH.SCOPE,
	authority: '/sts/v1/common',
	silent_redirect_uri: `${HOST.UI_URL_BASE}/oauth/silent_renew.html`,
	automaticSilentRenew: true,
	filterProtocolClaims: true,
	loadUserInfo: true,
	includeIdTokenInSilentRenew: false,
	extraQueryParams: { 'subscription-key': HOST.APIM_SUBSCRIPTION_KEY }
};

export const AUTHPROVIDERSETTINGS = {
	APIm: HOST.APIM_SUBSCRIPTION_KEY,
	client_id: OAUTH.CLIENTID,
	callback_url: `${HOST.UI_URL_BASE}/oauth/silent_renew.html`,
	scope: OAUTH.SCOPE,
	authority_url: `/sts/v1/common`
};
